import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import { RotateCw } from "feather-icons-react/build/IconComponents";
import AddCategoryList from "../../core/modals/inventory/addcategorylist";
import EditCategoryList from "../../core/modals/inventory/editcategorylist";
import Table from "../../core/pagination/datatable";
import { FetchNewDataForPOwerBI, GetRequest } from "../../Api/ApiFunctions";
import { message } from "antd";

const EtlDashboard = () => {
  const [dataSource, setDataSource] = useState(null);
  const fetchData = async () => {
    const res = await GetRequest("etl");
    if (res) {
      setDataSource(res);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const NewDataRefreshButtonClicked = async () => {
    const res = await FetchNewDataForPOwerBI();
    if (res) {
      message.success("New data has begun to be processed.");
    }
  };

  const columns = [
    {
      title: "Fetch Time",
      dataIndex: "created_at",
      render: (_, record) => (
        <div>{new Date(record?.created_at).toLocaleDateString()}</div>
      ),
      sorter: (a, b) => a.created_at.length - b.created_at.length,
    },
    {
      title: "Total Data Fetched",
      dataIndex: "total_data_fetched",
    },
    {
      title: "Api Calls",
      dataIndex: "total_api_calls",
    },
    {
      title: "Fetch Status",
      dataIndex: "status",
      render: (_, record) => (
        <span
          className={`badge bg-outline-${
            record?.total_process_task == record?.total_subprocess_task
              ? "success"
              : "danger"
          }`}
        >
          {record?.total_process_task == record?.total_subprocess_task
            ? "Completed"
            : `${record?.failed_task} Task Failed`}
        </span>
      ),
    },
  ];
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>ETL Dashboard</h4>
                <h6>Manage your Data Pipelines</h6>
              </div>
            </div>

            <div className="page-btn">
              <div
                className="btn btn-added"
                onClick={NewDataRefreshButtonClicked}
              >
                <RotateCw className="me-2" />
                Fetch New Data
              </div>
            </div>
          </div>
          {/* /product list */}
          <div className="card ">
            <div className="table-responsive">
              <Table columns={columns} dataSource={dataSource} />
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <AddCategoryList />
      <EditCategoryList />
    </div>
  );
};

export default EtlDashboard;
